<template>
  <b-form-select
    v-if="dropdown || nullable"
    :value="value"
    :disabled="disabled"
    :options="options"
    :state="error ? false : null"
    @input="$emit('input', $event)">
  </b-form-select>
  <b-form-checkbox
    v-else
    :disabled="disabled"
    :checked="value"
    :state="error ? false : null"
    @input="$emit('input', $event)">
    <template v-if="inline">{{ label }}</template>
  </b-form-checkbox>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import BooleanFieldMixin from 'vue-forms/mixins/BooleanFieldMixin';

export default {
  mixins: [ FormFieldMixin, BooleanFieldMixin ],

  computed: {
    options() {
      const values = [
        { value: true, text: "Si" },
        { value: false, text: "No" },
      ];

      if (this.nullable) {
        return [
          { value: null, text: "" },
          ...values
        ];
      }

      return values;
    }
  }
};
</script>
